module.exports = __webpack_public_path__ + "img/image31.987188b7.png";